/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import { ApplyChannelData } from '@/api/apply-product/types';
import { Component, Prop, Vue } from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'OldChangeChannel' })
export default class OldChangeChannel extends Vue {
  @Prop(Object) readonly channelList!: ApplyChannelData[];

  private onChannelClick(channel: ApplyChannelData) {
    this.$emit('reApply', channel);
  }

  private render() {
    return (
      this.channelList.length > 0 && (
        <div class={style.channelList}>
          <div class={style.header}>更换提现机构</div>
          <div class={style.channelItems}>
            {this.channelList.map((channelItem) => (
              <div
                key={channelItem.productId}
                class={style.channelItem}
                onClick={this.onChannelClick.bind(this, channelItem)}
              >
                <span class={style.iconWrapper}>
                  <span
                    class={style.icon}
                    style={
                      channelItem.productIcon && {
                        backgroundImage: `url(${channelItem.productIcon})`,
                      }
                    }
                  />
                </span>
                <span class={style.nameWrap}>
                  <span class={style.name}>{channelItem.productName}</span>
                </span>
                <span class={style.creditWrapper}>
                  额度
                  <span class={style.credit}>{channelItem.availableAmount}</span>
                  元
                </span>
              </div>
            ))}
          </div>
        </div>
      )
    );
  }
}
